/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/matamo/matomo-module.ts.
 */
import {NgModule} from '@angular/core';

import {MatomoInjector} from './service/matomo-injector.service';
import {MatomoTracker} from './service/matomo-tracker.service';

@NgModule({
  providers: [MatomoInjector, MatomoTracker],
})
/**
 * Zweck: Beschreibt class MatomoModule und ihren Daten- oder Funktionsvertrag.
 */
export class MatomoModule {
}
